<template >
  <v-container fluid>
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("labels.filters") }}</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom"
          ><template slot="activator">
            <v-btn flat="flat" @click="reset" icon="icon">
              <v-icon>autorenew</v-icon>
            </v-btn> </template
          ><span>Reset</span></v-tooltip
        >
        <v-tooltip class="ml-1 pointer" bottom="bottom"
          ><template slot="activator">
            <v-btn flat="flat" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn> </template
          ><span>Fetch Data</span></v-tooltip
        >
      </v-toolbar>
      <v-card-text>
        <v-layout row="wrap">
          <v-flex xs12 sm6>
            <VueCtkDateTimePicker
              v-model="setDate"
              label="Select Date Range"
              range="range"
              @input="setDateTime"
            ></VueCtkDateTimePicker>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.promotion") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search"
          clearable="clearable"
          single-line="single-line"
          hide-details="hide-details"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="promotion_Id"
        :items="promotion"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        ><template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ props.item.promotion_Id }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
            </td>
            <td
              v-if="!location"
              class="text-xs-left"
              @click="props.expanded = !props.expanded"
            >
              {{ props.item.Store.CSPID }}
            </td>
            <td
              v-if="!location"
              class="text-xs-left"
              @click="props.expanded = !props.expanded"
            >
              {{ props.item.Store.businessName }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ props.item.messageType }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ props.item.sentCount }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{ props.item.status }}
            </td>
          </tr> </template
        ><template slot="expand" slot-scope="props">
          <v-card>
            <v-card-text>
              <v-layout row="wrap">
                <v-flex xs12 sm6>
                  <h3 class="font-weight-regular mb-3">Promotion</h3>
                  <div>
                    <span class="mr-1">{{ $t("labels.sendCount") }}: </span
                    ><span class="font-weight-medium">{{
                      props.item.sentCount
                    }}</span>
                  </div>
                  <div>
                    <span class="mr-1">{{ $t("labels.deliverdCount") }}:</span
                    ><span class="font-weight-medium">{{
                      props.item.deliveredCount
                    }}</span>
                  </div>
                  <div>
                    <span class="mr-1">{{ $t("labels.costPrice") }}:</span
                    ><span class="font-weight-medium">{{
                      props.item.costPrice | currency
                    }}</span>
                  </div>
                  <div>
                    <span class="mr-1"
                      >{{ $t("labels.initialHoldingValue") }}:</span
                    ><span class="font-weight-medium">{{
                      props.item.initialHoldValue | currency
                    }}</span>
                  </div>
                  <div>
                    <span class="mr-1"
                      >{{ $t("labels.afterDeliveredValue") }}:</span
                    ><span class="font-weight-medium">{{
                      props.item.afterDeliveredValue | currency
                    }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6>
                  <h3 class="font-weight-regular mb-3">Message</h3>
                  <div class="mt-1">{{ $t("labels.status") }}</div>
                  <div class="font-weight-medium">
                    {{ props.item.status }}
                    <v-btn
                      v-if="props.item.status === 'Pending' || props.item.status === 'queued'"
                      @click="sync(props.item)"
                      round
                      small
                      color="success"
                      >Sync</v-btn
                    >
                  </div>
                  <div class="mt-1">{{ $t("labels.message") }}</div>
                  <div class="font-weight-medium">{{ props.item.message }}</div>
                  <div class="mt-1" v-if="props.item.mediaUrl">
                    {{ $t("labels.imageURL") }}
                  </div>
                  <div class="font-weight-medium" v-if="props.item.mediaUrl">
                    {{ props.item.mediaUrl }}
                  </div>
                </v-flex>
                <v-layout row="wrap" v-if="!location">
                  <v-btn color="info" @click="gotoPage(props.item)"
                    >Go to page</v-btn
                  >
                </v-layout>
              </v-layout>
            </v-card-text>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import promotionService from "../service";

export default {
  props: ["location"],
  data() {
    return {
      setDate: {
        start: this.$moment(new Date())
          .subtract(10, "days")
          .format("YYYY-MM-DD"),
        end: this.$moment(new Date()).format("YYYY-MM-DD"),
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(10, "days"),
        toDate: this.$moment(new Date()),
      },
      headers: [],
      search: null,
      promotion: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "promotion_Id",
        descending: true,
      },
    };
  },
  components: {
    VueCtkDateTimePicker,
  },
  async created() {
    this.loadHeader();
    await this.resetList();
    if (this.location) {
      await this.getByStoreId();
    } else {
      await this.getList();
    }
  },
  methods: {
    sync(obj) {
      console.log("obj", obj);
      this.getSettlementById(obj.promotion_Id);
    },
    showSyncButton(val) {
      console.log("showSyncButton", val);
      if (val.status === "Pending" || val.status === "queued") {
        return false;
      } else {
        return false;
      }
    },
    loadHeader() {
      this.headers.push({
        text: this.$t("labels.id"),
        value: "promotion_Id",
        sortable: true,
        width: "5%",
      });
      this.headers.push({
        text: this.$t("labels.createdAt"),
        value: "createdAt",
        sortable: true,
      });
      if (!this.location) {
        this.headers.push({
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
        });
      }
      if (!this.location) {
        this.headers.push({
          text: this.$t("labels.storeName"),
          value: "Store.businessName",
          sortable: true,
        });
      }

      this.headers.push({
        text: this.$t("labels.messageType"),
        value: "messageType",
        sortable: true,
      });
      this.headers.push({
        text: this.$t("labels.sendCount"),
        value: "sentCount",
        sortable: true,
      });
      this.headers.push({
        text: this.$t("labels.status"),
        value: "refID.fullName",
        sortable: true,
      });
    },
    setDateTime(val) {
      if (val) {
        if (val.start) this.filter.fromDate = val.start;
        if (val.end) this.filter.toDate = val.end;
      }
    },
    gotoPage(data) {
      this.$router.push({ path: `/location/profile/${data.Store.storeID}` });
    },
    reset() {
      this.resetList();
      if (this.location) {
        this.getByStoreId();
      } else {
        this.getList();
      }
    },
    resetList() {
      this.filter.fromDate = this.$moment(new Date()).subtract(10, "days");
      this.filter.toDate = this.$moment(new Date());
      if (this.$refs.dateTimePicker) this.$refs.dateTimePicker.reset();
    },
    reloadData() {
      this.loading = true;
      this.promotion = [];
      const proFilter = {};
      if (this.filter.fromDate) {
        proFilter.fromDate = this.$moment(this.filter.fromDate).format(
          "MM/DD/YYYY h:m a"
        );
      }
      if (this.filter.toDate) {
        proFilter.toDate = this.$moment(this.filter.toDate).format(
          "MM/DD/YYYY h:m a"
        );
      }

      if (this.location) {
        this.getByStoreId();
      } else {
        this.getList();
      }
    },
    getSettlementById(id) {
      this.loading = true;
      promotionService
        .getSettlementById(id)
        .then((response) => {
          console.log("result", response);
          if (this.location) {
            this.getByStoreId();
          } else {
            this.getList();
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("error", error);
        });
    },
    getByStoreId() {
      this.loading = true;
      this.promotion = [];
      const proFilter = {
        fromDate: this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a"),
      };
      console.log("location id", this.location);
      promotionService
        .getByStoreId(this.location.storeID, proFilter)
        .then((response) => {
          console.log("result", response);
          if (this.location) {
            this.promotion = response.data;
            this.loading = false;
          } else {
            Promise.all(
              response.data.map((promotion) => {
                if (promotion.Store) {
                  this.promotion.push(promotion);
                }
              })
            )
              .then((result) => {
                this.loading = false;
                return response;
              })
              .catch((error) => {
                this.loading = false;
                console.log("error", error);
              });
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log("error", error);
        });
    },
    getList() {
      this.loading = true;
      this.promotion = [];
      const proFilter = {
        fromDate: this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a"),
      };
      promotionService
        .getAll(proFilter)
        .then((response) => {
          console.log("result", response);
          Promise.all(
            response.data.map((promotion) => {
              if (promotion.Store) {
                this.promotion.push(promotion);
              }
            })
          )
            .then((result) => {
              this.loading = false;
              return response;
            })
            .catch((error) => {
              this.loading = false;
              console.log("error", error);
            });
        })
        .catch((error) => {
          this.loading = false;
          console.log("error", error);
        });
    },
  },
};
</script>

<style scoped></style>
